import React from "react";
import { Link } from "react-router-dom";

/**
 * Logo holder component for the header.
 * Uses React Router Link for client-side navigation to preserve cache.
 * @param {Object} props - Component props
 * @param {string} props.src - Logo image source URL
 * @param {string} props.color - Text color (unused but kept for API compatibility)
 * @param {string} props.hoverColor - Hover color (unused but kept for API compatibility)
 */
function LogoHolder({ src, color, hoverColor }) {
  if (src) {
    return (
      <Link to="/">
        <img
          id="header-logo"
          className="header-logo"
          src={src}
          alt="logo"
        />
      </Link>
    );
  }
}

export default LogoHolder;
